// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39ZSh","colMin":"styles_colMin__2Pw36"};